import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import Profile from './icons/Profile';
import useUI from '../contexts/useUI';

export default function NavBar() {
  const navigate = useNavigate();
  const { profileHighlighted } = useUI();

  return (
    <div
      className="navbar"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '56px',
        padding: '0 16px',
        borderBottom: '1px solid var(--border)',
        backgroundColor: 'var(--card-bg)',
      }}
    >
      <Logo />
      <button
        id="profile-button"
        onClick={() => navigate('/profile')}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: profileHighlighted ? 'var(--gold)' : 'none',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          padding: '8px',
          width: profileHighlighted ? '40px' : 'auto',
          height: profileHighlighted ? '40px' : 'auto',
          stroke: profileHighlighted ? 'var(--card-bg)' : 'var(--primary-soft)',
          transition: 'all 0.2s ease',
          position: 'relative',
          animation: profileHighlighted
            ? 'pulse 1.5s ease-in-out infinite'
            : 'none',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.stroke = 'var(--accent)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.stroke = 'var(--primary-soft)';
        }}
      >
        <Profile />
      </button>
    </div>
  );
}
